import { Menu } from "@mantine/core";
import { useRef } from "react";
import type { Person } from "../../../../../../utils/backend-types";
import { clearFileInput } from "../VollmachtSection";
import { UploadVollmachtButton } from "./UploadVollmachtButton";

interface UploadVollmachtPersonMenuProps {
  persons: Array<Pick<Person, "id" | "name">>;
  onFilesSelected: (personId: number, files: Array<File>) => void;
  disabled?: boolean;
}

function UploadVollmachtPersonMenu({
  disabled,
  persons,
  onFilesSelected
}: UploadVollmachtPersonMenuProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const selectedPersonIdRef = useRef<number | null>(null);

  function handlePersonClick(personId: number) {
    selectedPersonIdRef.current = personId;
    fileInputRef.current?.click();
  }

  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const personId = selectedPersonIdRef.current;
    const files = Array.from(event.target.files ?? []);

    clearFileInput(fileInputRef);
    selectedPersonIdRef.current = null;

    if (files.length === 0 || !personId) {
      return;
    }

    onFilesSelected(personId, files);
  }

  return (
    <>
      <Menu>
        <Menu.Target>
          <UploadVollmachtButton disabled={disabled} />
        </Menu.Target>

        <Menu.Dropdown>
          {persons.map((person) => (
            <Menu.Item
              key={person.id}
              onClick={() => handlePersonClick(person.id)}
            >
              {person.name}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
      <input
        accept="application/pdf"
        hidden
        ref={fileInputRef}
        type="file"
        onChange={handleFileChange}
      />
    </>
  );
}

export { UploadVollmachtPersonMenu };
